import { render, staticRenderFns } from "./ReportMatReceive.vue?vue&type=template&id=29f02a2e&scoped=true&"
import script from "./ReportMatReceive.vue?vue&type=script&lang=js&"
export * from "./ReportMatReceive.vue?vue&type=script&lang=js&"
import style0 from "./ReportMatReceive.vue?vue&type=style&index=0&id=29f02a2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f02a2e",
  null
  
)

export default component.exports